import type { ComponentProps } from "react";

import { PointContactContent } from "@features/point-inner-content/point-contact-content";

import { ContactLink } from "@shared/ui/contact-link";
import { Body } from "@shared/ui/typography";

import type { CafesRestaurantsPointType } from "@/_pages/cafes-restaurants/model/types";

import s from "../point-contact-content.module.scss";

export type CompProps = ComponentProps<"div"> & {
  data: CafesRestaurantsPointType;
  isTablet?: boolean;
};

export const CafesRestaurantsContent = (props: CompProps) => {
  const { data, isTablet } = props;

  const addressContent = data.location ? (
    <Body size="uppercase-small" weight="semiBold">
      {data.location}
    </Body>
  ) : null;

  const contactsContent =
    data.phone || data.email ? (
      <div className={s.valueList}>
        {data.phone && (
          <ContactLink type="phone" value={data.phone} className="global-link">
            <Body size="uppercase-small" weight="semiBold">
              {data.phone}
            </Body>
          </ContactLink>
        )}
        {data.email && (
          <ContactLink type="email" value={data.email} className="global-link">
            <Body size="uppercase-small" weight="semiBold">
              {data.email}
            </Body>
          </ContactLink>
        )}
      </div>
    ) : null;

  const workTimeContent =
    data?.workTimeList && data?.workTimeList?.length > 0 ? (
      <div className={s.valueListNoGap}>
        {data.workTimeList.map((item, idx) =>
          item?.timeSlot != null && item.timeSlot !== "" ? (
            <Body
              key={item?.id ?? item?.timeSlot ?? idx}
              size="uppercase-small"
              weight="semiBold"
            >
              {item.timeSlot}
            </Body>
          ) : null,
        )}
      </div>
    ) : null;

  const infoContent =
    data.averageCheck || data.cuisine ? (
      <div className={s.valueList}>
        {data.averageCheck && (
          <Body size="uppercase-small" weight="semiBold">
            {data.averageCheck}
          </Body>
        )}
        {data.cuisine && (
          <Body size="uppercase-small" weight="semiBold">
            {data.cuisine}
          </Body>
        )}
      </div>
    ) : null;

  return (
    <PointContactContent
      items={[
        {
          key: "location",
          title: "Адрес",
          iconName: "location",
          iconColor: "cadmium",
          content: addressContent,
        },
        {
          key: "contacts",
          title: "Контакты",
          iconName: "phone",
          iconColor: "violet",
          content: contactsContent,
        },
        {
          key: "worktime",
          title: "Часы работы",
          iconName: "clock",
          iconColor: "azure",
          content: workTimeContent,
        },
        {
          key: "info",
          title: "Информация о заведении",
          iconName: "food",
          iconColor: "cadmium",
          content: infoContent,
        },
      ]}
      siteUrl={data.siteLink}
      mapAnchorId="cafes-restaurants-map"
      isTablet={isTablet}
    />
  );
};

CafesRestaurantsContent.displayName = "CafesRestaurantsContent";
